import { useEffect, useRef } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useAuth0 } from "@auth0/auth0-react";
import Typography from "@mui/material/Typography";
import LoadingAbortPaper from "../components/Reusable/LoadingAbortPaper";
import { writeViewAs } from "../viewAs";

/**
 * /view-as/:userId -- where Red Panda's "View in Central" button lands.
 *
 * Records the target for this tab, then goes through the normal login. The
 * choice rides across the Auth0 redirect in sessionStorage, and LoginGuard
 * decides whether the signed-in user may actually use it. Outside LoginGuard on
 * purpose: someone arriving here is usually not logged in yet.
 */
export default function ViewAsEntry() {
  const { userId } = useParams();
  const { isAuthenticated, isLoading, loginWithRedirect } = useAuth0();
  const navigate = useNavigate();
  const started = useRef(false);

  const target = /^[1-9]\d*$/.test(userId) ? Number(userId) : null;

  useEffect(() => {
    if (target === null || isLoading || started.current) return;
    started.current = true;

    writeViewAs({ actorSub: null, target });
    if (isAuthenticated) navigate("/dashboard", { replace: true });
    else loginWithRedirect();
  }, [target, isLoading, isAuthenticated, navigate, loginWithRedirect]);

  if (target === null) {
    return (
      <LoadingAbortPaper>
        <Typography>That view-as link is not valid.</Typography>
      </LoadingAbortPaper>
    );
  }

  return <div>Opening WRS Central...</div>;
}
